import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';

import { CmsItemConfiguration } from '@lib-shared/cms/models/cms-item-configuration.class';

import { CmsCollectionEnum } from '@lib-shared/cms/models/cms-collection.enum';

import { CmsDirectService } from '@lib-shared/cms/services/cms-direct.service';
import { CmsStoreService } from '@lib-shared/cms/services/cms-store.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceStoreService {
  /**
   * constructor
   *
   */
  constructor(
    private cmsStoreService: CmsStoreService,
    private cmsDirectSercice: CmsDirectService,
  ) {}

  /**
   * getIsActiveFromStore
   *
   */
  getIsActiveFromStore$(reload: boolean = false): Observable<boolean> {
    const init$ = reload ? this.getStoreReloadStream$() : of(false);

    return init$.pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.getStoreIsActiveStream$()),
    );
  }

  /**
   * getMaintenanceStream
   *
   */
  getIsActiveFromDirect$(): Observable<any> {
    return this.cmsDirectSercice.getConfiguration().pipe(
      take(1),
      map((config) => config?.maintenance_enabled),
      catchError(() => of(false)),
    );
  }

  /**
   * getIsActiveMixed$
   *
   */
  getIsActiveMixed$() {
    return this.getIsActiveFromStore$().pipe(
      switchMap((isActive) =>
        isActive ? of(true) : this.getIsActiveFromDirect$(),
      ),
    );
  }

  /**
   * getStoreReloadStream
   *
   */
  private getStoreReloadStream$(): Observable<boolean> {
    this.cmsStoreService.loadCollection(CmsCollectionEnum.Configuration, true, {
      id: 'mymillennium',
    });
    return this.cmsStoreService.getCollectionIsLoading(
      CmsCollectionEnum.Configuration,
    );
  }

  /**
   * getStoreIsActiveStream
   *
   */
  private getStoreIsActiveStream$(): Observable<boolean> {
    return this.cmsStoreService
      .getOneCollectionItemById(CmsCollectionEnum.Configuration, 'mymillennium')
      .pipe(
        map(
          (configuration: CmsItemConfiguration) =>
            configuration?.maintenance_enabled,
        ),
      );
  }
}
